import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {FormControl, Select, MenuItem, LinearProgress, withStyles} from '@material-ui/core';
import SelectInput from './select-input';
import LockIcon from '@material-ui/icons/LockOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import {Period} from './typedef';
import {getMonthNameByIndex} from '../../utils/getMonthNameByIndex';
import {setPeriodAction} from '../../modules/main-container/services/actions';

import {useStyles} from './styles';

const Preloader = () => {
    const classes = useStyles();

    return <LinearProgress color="primary" className={classes.preloader} />;
};

type PeriodSelectProps = {
    periods: Period[];
    calendar: Period;
    handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

const PeriodSelect = ({calendar, periods, handleChange}: PeriodSelectProps) => {
    const classes = useStyles();

    return (
        <FormControl>
            <Select
                value={calendar.id}
                input={<SelectInput name="period" />}
                onChange={handleChange}
                classes={{select: classes.select}}>
                {periods.map((p: Period) => {
                    const periodName = `${getMonthNameByIndex(p.month)}  ${p.year}`;
                    return (
                        <MenuItem key={p.id} value={p.id} className={classes.menuItem}>
                            {p.locked ? (
                                <LockIcon className={classes.periodIcon} />
                            ) : (
                                <LockOpenIcon className={classes.periodIcon} />
                            )}
                            {periodName}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

interface Dispatch {
    setPeriodAction: typeof setPeriodAction;
}

interface OwnProps {
    periods: Period[];
    calendar: Period;
    current: Period;
    handlePeriodChange: (id: number) => void;
}

type IProps = OwnProps & Dispatch;

const PeriodPicker = (props: IProps) => {
    const {periods, calendar, current} = props;

    useEffect(() => {
        props.setPeriodAction(current);
    }, []);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const id = Number(event.target.value);

        if (id !== calendar.id) {
            const newPeriod: Period = periods.filter((p: Period) => Number(p.id) === id)[0] || periods[0];
            props.setPeriodAction(newPeriod);
            if (props.handlePeriodChange) {
                props.handlePeriodChange(id);
            }
        }
    };

    return (
        <>
            {periods && calendar ? (
                <PeriodSelect calendar={calendar} periods={periods} handleChange={handleChange} />
            ) : (
                <Preloader />
            )}
        </>
    );
};

const mapStateToProps = (state: any) => ({
    periods: state.periods.list,
    current: state.periods.current,
    calendar: state.periods.calendar
});

const connector = connect(mapStateToProps, {setPeriodAction});

export default connector(PeriodPicker);
